var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m101.589 229.928 62.008 60.7a40.071 40.071 0 0 1 11.451 35.263l-14.483 85.557 76.9-40.219a40.011 40.011 0 0 1 37.079 0l76.887 40.216-14.485-85.555a40.07 40.07 0 0 1 11.454-35.262l62.006-60.7-85.839-12.662a40 40 0 0 1-29.994-21.789L256 117.739l-38.573 77.737a39.991 39.991 0 0 1-29.985 21.789l-85.85 12.663zm82.349-36.406a15.984 15.984 0 0 0 11.988-8.713L256 63.745l60.072 121.064a15.983 15.983 0 0 0 12 8.713l133.688 19.721-96.568 94.535a15.962 15.962 0 0 0-4.577 14.106l22.556 133.244L263.418 392.5a16.011 16.011 0 0 0-14.832 0l-119.757 62.628 22.556-133.244a15.964 15.964 0 0 0-4.576-14.106l-96.573-94.535 133.7-19.721zM118.445 324.79 4.808 213.549a15.994 15.994 0 0 1 8.86-27.259l157.319-23.2 70.682-142.456a15.993 15.993 0 0 1 28.656 0l70.682 142.454 157.329 23.2a15.994 15.994 0 0 1 8.85 27.259L393.558 324.79 420.1 481.581a16 16 0 0 1-23.188 16.852L256 424.732l-140.911 73.7A16 16 0 0 1 91.9 481.581z",
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.4dedc4a873dc3f64ff18040305d83766.svg";
export { ForwardRef as ReactComponent };